/**
 * FeaturePath: 會員系統-個人資訊-證照登錄
 * Accountable: Landy Chu, AlexCH Cheng
 */

import objectAssign from 'object.assign';

import {
  SET_TARGET,
  SET_LIST,
  SET_LICENSE_UNIT,
  SET_LICENSE_IDCLASS,
  SET_IMAGE_LINK,
  SET_LICENSE_CONFIG,
} from 'react/constants/license';
// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || objectAssign;

// The initial application state
const initialState = {
  list: [],
  target: {
    _id: '',
    name: '',
    idClass: '',
    obtainDate: '',
    validStart: '',
    validEnd: '',
    isNoLimit: true,
    number: '',
    organization: '',
    note: '',
    copy: '',
    userId: '',
    createdAt: '',
    modifiedAt: '',
  },
  licenseUnit: [],
  licenseIdClass: [],
  link: '',
  licenseConfig: [],
};

// Takes care of changing the application state
export function license(state = initialState, action) {
  switch (action.type) {
    case SET_TARGET:
      return assign({}, state, {
        target: action.license,
      });
    case SET_LIST:
      return assign({}, state, {
        list: action.licenses,
      });
    case SET_LICENSE_UNIT:
      return assign({}, state, {
        licenseUnit: action.licenseUnit,
      });
    case SET_LICENSE_IDCLASS:
      return assign({}, state, {
        licenseIdClass: action.licenseIdClass,
      });
    case SET_IMAGE_LINK:
      return assign({}, state, {
        link: action.link,
      });
    case SET_LICENSE_CONFIG:
      return assign({}, state, {
        licenseConfig: action.data,
      });
    default:
      return state;
  }
}
